import React, { useContext, useState, useEffect, useCallback } from 'react';
import OrderCard from './src-components-AdvanceMessagingComponent-OrderList-OrderCard.js';
import { Box, FlexBox, Button, Spinner, Icon } from '@vp/swan';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { useCBFetchOrders } from './src-hooks-chatbot-useCBFetchOrders.js';
import { CAContext } from './src-contexts-CAContext.js';

const OrderList = ({
  orders,
  // onClick,
  ordersCount,
  sender
}) => {
  const {
    chatState: { scrollToBottom }
  } = useContext(CAContext);
  const { data, loading, trigger } = useCBFetchOrders();
  const {
    state: { sendChatbotMessage }
  } = useContext(ChatbotContext);
  const [ordersToShow, setOrdersToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showLoadMoreButton, setShowLoadMoreButton] = React.useState(false);
  useEffect(() => {
    if (orders) {
      setOrdersToShow(orders);
    }
  }, [orders]);
  const onOrderClick = useCallback(
    (orderId) => {
      const selectedOrder = ordersToShow.find((order) => order.orderId === orderId);
      if (sendChatbotMessage && selectedOrder) {
        sendChatbotMessage({
          type: "order_select",
          messageData: selectedOrder
        });
      }
    },
    [sendChatbotMessage, ordersToShow]
  );
  useEffect(() => {
    if (data) {
      setOrdersToShow((prevOrders) => [...prevOrders, ...data]);
      scrollToBottom?.();
    }
  }, [data]);
  const onLoadMore = useCallback(() => {
    trigger({ pageNumber: currentPage + 1 });
    setCurrentPage((prevPage) => prevPage + 1);
  }, [currentPage]);
  useEffect(() => {
    if (ordersToShow.length < ordersCount) {
      setShowLoadMoreButton(true);
    } else {
      setShowLoadMoreButton(false);
    }
  }, [ordersToShow, ordersCount]);
  return /* @__PURE__ */ React.createElement(Box, null, ordersToShow.map((order) => /* @__PURE__ */ React.createElement(
    OrderCard,
    {
      key: order.orderId,
      orderDate: order.orderDate,
      orderId: order.orderId,
      orderItems: order.orderItems,
      orderNumber: order.orderNumber,
      displayPrice: order.displayPrice,
      onClick: onOrderClick,
      sender
    }
  )), showLoadMoreButton && /* @__PURE__ */ React.createElement(FlexBox, { justifyContent: "space-around", marginBottom: "between-actions" }, /* @__PURE__ */ React.createElement(Button, { skin: "tertiary", onClick: onLoadMore, iconPosition: "left", disabled: loading }, loading ? /* @__PURE__ */ React.createElement(Spinner, { size: "mini", accessibleText: "loading" }) : /* @__PURE__ */ React.createElement(Icon, { iconType: "arrowDown" }), "Load more")));
};

export { OrderList as default };
//# sourceMappingURL=src-components-AdvanceMessagingComponent-OrderList-OrderList.js.map
